import anime from '@/assets/libs/anime';
import { inApp } from '@/scripts/utils';

export function buttonInit(el) {
  const ctx = el;
  const contetButtons = [...ctx.querySelectorAll('.button span')];
  const svgs = [...ctx.querySelectorAll('.button svg')];

  anime.set(contetButtons, { opacity: 0, scale: 0 });
  anime.set(svgs, { scale: 0 });
}

export function buttonAnim(el, delay = 0) {
  const ctx = el;
  ctx.style.pointerEvents = 'none';
  const contetButtons = [...ctx.querySelectorAll('.button span')];
  const svgs = [...ctx.querySelectorAll('.button svg')];
  const tl = anime.timeline({
    easing: 'cubicBezier(.5,0,0,1)',
    duration: inApp() ? 1000 : 1800,
    complete: () => {
      ctx.style.pointerEvents = 'auto';
    },
  });

  tl
    .add({
      targets: contetButtons,
      opacity: 1,
      scale: 1,
      delay: anime.stagger(300, { start: delay }),
    }, 200)
    .add({
      targets: svgs,
      scale: 1,
      delay: anime.stagger(350, { start: delay }),
    }, 0);

  return tl;
}

export function buttonOut(el, delay = 0) {
  const ctx = el;
  const contetButtons = [...ctx.querySelectorAll('.button span')];
  const svgs = [...ctx.querySelectorAll('.button svg')];
  const tl = anime.timeline({
    easing: 'cubicBezier(.5,0,0,1)',
    duration: inApp() ? 800 : 1200,
  });

  tl
    .add({
      targets: contetButtons,
      opacity: 0,
      scale: 0,
      delay: anime.stagger(300, { start: delay }),
    }, 0)
    .add({
      targets: svgs,
      scale: 0,
      delay: anime.stagger(350, { start: delay }),
    }, 300);

  return tl;
}
